"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertNonEmptyArray = assertNonEmptyArray;
function isNonEmptyArray(arr) {
    return arr.length > 0;
}
function assertNonEmptyArray(arr) {
    if (isNonEmptyArray(arr)) {
        return arr;
    }
    throw new Error("Array is Empty!");
}
//# sourceMappingURL=index.js.map